import { render, staticRenderFns } from "./AccountTypeStep.vue?vue&type=template&id=2ac45e01&"
import script from "./AccountTypeStep.vue?vue&type=script&lang=js&"
export * from "./AccountTypeStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports